import React from 'react';
import css from 'styled-jsx/css';
import DesktopView from './DesktopView';
import MobileView from './MobileView';
import withI18next from '~/../hocs/_withI18next';
import themeVariables from '~/shared/themeVariables';

@withI18next(['page-submission-guideline'])
class SubmissionGuidelinePage extends React.Component {
  render() {
    return (
      <div className="submission-guideline-page">
        <DesktopView {...this.props} />
        <MobileView {...this.props} />
        <style jsx>{styles}</style>
        <style jsx global>
          {globalStyles}
        </style>
      </div>
    );
  }
}

const styles = css`
  .submission-guideline-page {
    width: 100%;
    background: #fff;
  }
`;

const globalStyles = css.global`
  .ac-link {
    color: ${themeVariables.colors.primary};
    font-weight: 600;
    text-decoration: underline !important;
  }
  .ac-link:hover {
    color: ${themeVariables.colors.primary};
    opacity: 0.8;
  }
`;

export default SubmissionGuidelinePage;
